export default "__VITE_ASSET__gXynJ_pI__$_?url__"